import { render, staticRenderFns } from "./areaRecording.vue?vue&type=template&id=a38ef6be&scoped=true"
import script from "./areaRecording.vue?vue&type=script&lang=js"
export * from "./areaRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ef6be",
  null
  
)

export default component.exports